import { render, staticRenderFns } from "./CardReport.vue?vue&type=template&id=6a8df163&scoped=true"
import script from "./CardReport.vue?vue&type=script&lang=js"
export * from "./CardReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8df163",
  null
  
)

export default component.exports